module.exports = __webpack_public_path__ + "4192dc35b8a4a6bc0280124e0961124a.svg";